import "./App.css";
import { Route, Routes } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";

import AdminPrivateRoute from "./routes/AdminPrivateRoute";
import OrgPrivateRoute from "./routes/OrgPrivateRoute";
import Admin from "./routes/Admin";
import Organization from "./routes/Organization";

import Login from "./Pages/Login";
import { useDispatch } from "react-redux";
import "./assets/css/responsive.css";
import ForgotPassword from "./Pages/ForgotPassword";
import SetPassword from "./Pages/SetPassword";
import axios from "axios";
import Registration from "./Pages/Registration";
import Updatecode from "./Pages/Updatecode";
import Onboarding from "./Pages/Organization/Onboarding";
import CertificateVerificationPage from "./Pages/CertificateVerification";

function App() {
  const dispatch = useDispatch();
  const [login, setLogin] = useState(false);

  const sessionTimeout = 20 * 60 * 1000; // 5 minutes in milliseconds
  let activityTimeout;

  const resetTimeout = useCallback(() => {
    if (activityTimeout) clearTimeout(activityTimeout);
    activityTimeout = setTimeout(() => {
      sessionStorage.clear();
      window.location.href = "/";
    }, sessionTimeout);
  }, [activityTimeout, sessionTimeout]);

  const handleActivity = () => {
    // resetTimeout();
  };

  useEffect(() => {
    dispatch({ type: "DECODE_TOKEN" });

    axios
      .get("admin/login")
      .then((res) => {
        setLogin(res.data.login);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // useEffect(() => {
  //   if (!token && !key) return;
  //   dispatch({ type: LOGIN_ADMIN, payload: token });
  // }, [token, key, dispatch]);

  useEffect(() => {
    console.log("sessionTimeout", sessionTimeout);

    // Set initial timeout
    // resetTimeout();

    // Add event listeners to track user activity
    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keydown", handleActivity);
    window.addEventListener("click", handleActivity);

    // Cleanup event listeners on component unmount
    return () => {
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keydown", handleActivity);
      window.removeEventListener("click", handleActivity);
      if (activityTimeout) clearTimeout(activityTimeout);
    };
  }, [resetTimeout]);

  axios.interceptors.response.use(
    (response) => {
      return response; // If the request succeeds, just return the response
    },
    (error) => {
      // if (error.response && error.response.status === 403) {

      //   // Handle 403 error: automatic logout
      //   sessionStorage.clear();
      //   localStorage.clear();
      //   axios.defaults.headers.common["key"] = "";
      //   axios.defaults.headers.common["Authorization"] = "";
      //   window.location.href = "/";
      // }
      // else if (error.response && error.response.status === 500) {

      //   sessionStorage.clear();
      //   localStorage.clear();
      //   axios.defaults.headers.common["key"] = "";
      //   axios.defaults.headers.common["Authorization"] = "";
      //   window.location.href = "/";
      // }
      return Promise.reject(error); // For other errors, reject the promise
    },
  );
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={login ? <Login isOrgLogin={false} /> : <Registration />} />
        <Route path="/updateCode" element={<Updatecode />} />
        <Route path="/login" element={<Login isOrgLogin={false} />} />
        <Route path="/forgotPassword" element={<ForgotPassword />} />
        <Route path="/resetPassword" element={<SetPassword />} />
        <Route element={<AdminPrivateRoute />}>
          <Route path="/admin/*" element={<Admin />} />
        </Route>
        <Route path="/org/login" element={<Login isOrgLogin={true} />} />
        <Route element={<OrgPrivateRoute />}>
          <Route path="/org/register" element={<Onboarding />} />
          <Route path="/org/*" element={<Organization />} />
        </Route>
        <Route
          path="/certificate/verify/:id"
          element={<CertificateVerificationPage />}
        />
      </Routes>
    </div>
  );
}

export default App;
